<!--
 * @Description: input 去掉前后空格、状态有 【，】
 disabled:可编辑，不可编辑
 view:true,false =>true:详情 false:不受控制
 cxh
-->
<template>
  <CosInputView v-bind="$attrs" :value="value" v-if="view" />
  <a-input
    v-else
    v-bind="$attrs"
    v-model:value="modelValue"
    style="width: 100%"
    :placeholder="ignorePlaceHolder?'':(placeholder || $t('common.pleaseInput'))"
    :allowClear="allowClear"
    @blur="changeTrim"
  >
    <slot name="prefix"></slot>
    <slot name="suffix"></slot>
  </a-input>
</template>
<script lang="ts" setup>
import { useVModel } from '@vueuse/core'
import CosInputView from '../CosView/input.vue'
const props = defineProps({
  value: {
    type: [String, Number]
  },
  ignorePlaceHolder: {
    type: Boolean, // 是否忽略占位输入
    default: false
  },
  trim: {
    type: Boolean, // 去掉前后空格
    default: true
  },
  placeholder: {
    type: String
  },
  view: {
    type: Boolean
  },
  allowClear: {
    type: Boolean,
    default: true
  }
})
const emit = defineEmits(['update:value'])
const modelValue = useVModel(props, 'value', emit)
const changeTrim = () => {
  if (typeof modelValue.value === 'string' && props.trim) {
    modelValue.value = modelValue.value?.trim()
  }
}
</script>
